import { useEffect } from 'react';
import { SEUIL_AFFICHAGE_OFFRE_MS, VERSION_SEUIL_AFFICHAGE } from '../config/collecte';
import { noterEvenement } from '../services/collecte';
import type { EmplacementOffre } from '../types/pilotage';
import type { Offre } from '../types/offres';

/**
 * Note qu'une offre a été VUE : affichée en continu pendant `SEUIL_AFFICHAGE_OFFRE_MS`, écran actif.
 * Le temps ne se cumule pas : changer d'offre, quitter l'écran ou passer en arrière-plan le remet à
 * zéro. Ne rend rien et ne touche à aucun état de l'écran.
 */
export function useAffichageOffre(offre: Offre | null, emplacement: EmplacementOffre, actif: boolean): void {
  const cle = offre?.cle ?? null;
  useEffect(() => {
    if (!actif || cle === null) return;
    const minuteur = setTimeout(() => {
      noterEvenement(
        'offres_affichage',
        { objetType: 'offre', objetId: cle, emplacement, seuilVersion: VERSION_SEUIL_AFFICHAGE },
        { uneFoisParSession: true },
      );
    }, SEUIL_AFFICHAGE_OFFRE_MS);
    return () => clearTimeout(minuteur);
  }, [cle, emplacement, actif]);
}
